module.exports = __webpack_public_path__ + "static/media/undraw_code_thinking.4c4e44fa.svg";